export function canExportRequests(permissions, method) {
    return permissions?.export === true && method === 'store';
}
